fx.ns("desktop.book.edition", class LargeView extends shared.stage.BaseView {

    constructor(board)
    {
        super(board);

    }

    update(x, y, scale) {
        
        //this.scale = this.board.model.zoom.realValue;

        this.hideOthers();

        //this.move(x, y, scale, true);

     
    }

    select(area, animate)
    {
        // zoomed on the current area only : nothing to select
    }

    centerCurrentArea()
    {
        let xPos = (this.board.realWidth/this.board.currentArea.scale - this.board.currentArea.realWidth ) / 2;
        let yPos = this.board.scrollPosition/this.board.currentArea.scale + (this.board.realHeight/this.board.currentArea.scale - this.board.currentArea.realHeight ) / 2;

        /*this.applyPosition(this.board.currentArea, { scale : this.board.currentArea.scale,
            x : xPos,
            y :  yPos }, true);*/

            this.board.currentArea.css({ 
                "transform" : "scale(" + this.board.currentArea.scale + ") translate(" + xPos + "px, " + yPos + "px)",
                "transition" : "transform 0.25s"
            }); 

    }

    hideOthers()
    {
        let childs = this.board.getChilds();
      
        // Calculate the right width and height
        for (let i = 0; i < childs.length; i++) 
        {
            let child = childs[i];

            if (child != this.board.currentArea && !(child instanceof shared.stage.GuideLines))
                child.hide();
           
        }
    }

    move(x, y, scale, animate)
    {
        //this.scale = scale;

        this.board.currentArea.css({ 
            "transform" : "scale(" + this.board.currentArea.scale * scale + ") translate(" + x + "px, " + y + "px)",
            "transition" : animate ? "transform 0.25s" : "none"
        }); 

        /*this.applyPosition( this.board.currentArea, 
                            {    scale : this.board.currentArea.scale * this.scale,
                                x : x,
                                y :  y 
                            }, 
                            false, true);*/
            
    }

    scroll()
    {
        /*let viewPort = { top : this.board.scrollPosition, bottom : this.board.scrollPosition  + this.board.realHeight };
        let loadedAreas = [];
        for (let i = 0; i < this.board._editableAreas.length; i++)
        {
            let area = this.board._editableAreas[i];
            let position = area.getPosition();
            
            if (  ( position.y > viewPort.top  && position.y < viewPort.bottom ) || ( position.y + area.realHeight * area.scale > viewPort.top && position.y + area.realHeight * area.scale < viewPort.bottom ) )
            {
                area.load();
                area.visibleSurface = this.board.realHeight - ( Math.max(0, position.y - viewPort.top) + viewPort.bottom - Math.min(viewPort.bottom, position.y + area.realHeight*area.scale));
                loadedAreas.push(area);
            }
            else
            {
                area.unload();
            }
        }

        
        let activeArea;

        // let's find the most visible and set it active
        for (let i = 0; i < loadedAreas.length; i++)
        {
            let area = loadedAreas[i];
            if (!activeArea || activeArea.visibleSurface < area.visibleSurface)
                activeArea = area;
        }*/

        /*if (activeArea != this.board.currentArea)
        this.board.currentArea = activeArea;*/
    }
});